import { Namespace, TFunction } from 'react-i18next';

import { ReactComponent as ChartIcon } from './images/chart-icon.svg';
import { ReactComponent as FilterIcon } from './images/filter-icon.svg';
import { ReactComponent as ProfileIcon } from './images/profile-icon.svg';
import { ReactComponent as RocketIcon } from './images/rocket-icon.svg';

export const getBenefitsList = (t: TFunction<Namespace>) => {
  return [
    {
      caption: t('app:promoteVipPopup.benefits.filters'),
      icon: FilterIcon,
    },
    {
      caption: t('app:promoteVipPopup.benefits.icon'),
      icon: ProfileIcon,
    },
    {
      caption: t('app:promoteVipPopup.benefits.popularity'),
      icon: ChartIcon,
    },
    {
      caption: t('app:promoteVipPopup.benefits.guide'),
      icon: RocketIcon,
    },
  ];
};
